import { render, staticRenderFns } from "./CollectionAddChangePlan.vue?vue&type=template&id=62e04b30&scoped=true"
import script from "./CollectionAddChangePlan.vue?vue&type=script&lang=js"
export * from "./CollectionAddChangePlan.vue?vue&type=script&lang=js"
import style0 from "./CollectionAddChangePlan.vue?vue&type=style&index=0&id=62e04b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e04b30",
  null
  
)

export default component.exports